// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__R3k4M","slick-next":"CustomSlider_slick-next__ZpERz"};